<!--
 * @Description: 环形图
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-22 17:07:50
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-03-29 16:50:54
 -->
<template>
  <div class="annularStatics">
    <div class="item" v-for="(item, index) in staticsData" :key="index">
        <CircularProgress :strokeWidth="8" :strokeColor="item.color" :trailWidth="8" trailColor="#d9d9d9" :percent="70" >
          <div class="label">{{item.title}}</div>
          <div class="value">{{item.value}}</div>
        </CircularProgress>
    </div>
  </div>
</template>

<script>
import CircularProgress from './components/circularProgress'
export default {
  name: 'annularStatics',
  components: {
    CircularProgress,
  },
  data () {
    return {
      staticsData: [
        {
          name: 'wxaUser',
          title: '小程序注册人数',
          value: 0,
          color: '#1cfff0',
        },
        {
          name: 'event',
          title: '办理事件数量',
          value: 0,
          color: '#ffa524',
        },
        {
          name: 'patrol',
          title: '巡检任务数量',
          value: 0,
          color: '#06ff75',
        },
        {
          name: 'car',
          title: '管理车辆数量',
          value: 0,
          color: '#00ffff',
        },
      ],
    }
  },
  methods: {
    /**
     * @description                   获取数据
     * @return {undefied}             无返回值
     */
    getData () {
      this.$http.get('/rest/screen/lcgl/summary').then(res => {
        if (res.code === 0) {
          this.staticsData.map(k => {
            k.value = res.data[k.name]
          })
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
  },
  created () {
    this.getData()
  },
}
</script>

<style lang="less" scoped>
  .annularStatics {
    width: 100%;
    height: 100%;
    display: inline-flex;
    justify-content: space-around;
    align-items: center;
    align-content: space-around;
    flex-wrap: wrap;
    .item {
      display: inline-flex;
      justify-content: space-around;
      align-items: center;
      width: 50%;
      height: 50%;
      text-align: center;
    }
    /deep/.el-progress--circle {
      margin-top: 3%;
      .el-progress__text {
        width: 60% !important;
        margin-left: 20%;
        font-size: 1.8vh !important;
        color: #fff;
        line-height: 2.2vh;
      }
    }
  }
</style>
